export const CARDS_PRODUCT =  {
    REVOLVING: '500003',
    VIRTUAL_ONLY_CREDIT: '500803',
    VIRTUAL_DEBIT_CARD: '506012',
    OPEN_YOUNG: '506010',
    OPEN_DEBIT_CARD: '506002',
    METALLIC_CARD: 'metallic',
    MAESTRO_CARD: 'maestro',
    NERUDA_CARD: '500802',
    VANITY_CARD: '500805',
    HORMIGUERO_CARD: '500804',
};
